import { CustomerTrialDetail } from "../types/customer/CustomerTrialDetail";
import { axiosWithAuth } from "../utils/customAxios";

const trialService = {
    upgradeLicense: async (customerId: number) => {
        try {
            const response = await axiosWithAuth.put(`/customer/${customerId}/upgradeLicenses`);
            return response.data;
        } catch (err) {
            throw err;
        }
    },
    getCustomerTrialDetails: async (customerId: number): Promise<CustomerTrialDetail> => {
        const response = await axiosWithAuth.get(`/customer/${customerId}/trialconfig`);
        const trialDetail: CustomerTrialDetail = response.data;
        return trialDetail;
    },
}

export default trialService